import decode from "jwt-decode";
import api from "../api";
import { obterDispositivo2fa, salvarDispositivo2fa, removerDispositivo2fa } from "../utils/dispositivo2fa";

export const usuarioCadastrado = user => ({
  type: 'USUARIO_CADASTRADO',
  user
});

export const userLoggedIn = user => ({
  type: 'USUARIO_LOGADO',
  user
});

export const userLoggedOut = () => ({
  type: 'USUARIO_DESLOGADO'
});

export const emailRecuperacaoSenhaEnviado = user => ({
  type: 'EMAIL_RECUPERACAO_SENHA_ENVIADO',
  user
});

export const cadastroUsuarioConfirmado = user => ({
  type: 'CADASTRO_USUARIO_CONFIRMADO',
  user
});

export const senhaRecuperada = user => ({
  type: 'SENHA_RECUPERADA',
  user
});

export const tokenRecuperacaoSenhaConfirmado = user => ({
  type: 'TOKEN_RECUPERACAO_SENHA_CONFIRMADO',
  user
});

export const tokenConfirmacaoTrocaEmailConfirmado = user => ({
  type: 'TOKEN_CONFIRMACAO_TROCA_EMAIL_CONFIRMADO',
  user
});

export const tokenReverterTrocaEmailConfirmado = user => ({
  type: 'TOKEN_REVERTER_TROCA_EMAIL_CONFIRMADO',
  user
});

export const updateUsuarioSucesso = user => ({
  type: 'UPDATE_USUARIO_SUCESSO',
  user
});

export const isAuthenticated = token => {
  if (token) {
    try {
      const usuario = decode(token);
      const payload = decode(localStorage[process.env.REACT_APP_LOCALSTORAGE_AUTH_TOKEN]);
      return (usuario.id === payload.id)
    } catch (error) {
      return false
    }
  }
  return false
}

const concluirLogin = (data, dispatch) => {
  localStorage[process.env.REACT_APP_LOCALSTORAGE_AUTH_TOKEN] = data.token;
  dispatch(userLoggedIn(data));
  return data;
};

// resolve com { requer2fa, tempToken, metodo, email } quando o usuário precisa informar o segundo fator
// (metodo "email": código enviado ao e-mail; "app": aplicativo autenticador)
export const login = (email, senha, captchaToken) => dispatch =>
  api.usuario.login(email, senha, captchaToken, obterDispositivo2fa(email)).then(data => {
    if (data.requer2fa) {
      // o navegador lembrado não vale mais (expirou ou foi encerrado): descarta o token local
      removerDispositivo2fa(email);
      return { requer2fa: true, tempToken: data.tempToken, metodo: data.metodo, email: data.email };
    }
    return { user: concluirLogin(data, dispatch).user };
  });

export const reenviarCodigoLogin2fa = tempToken => () =>
  api.usuario.reenviarCodigoLogin2fa(tempToken);

// lembrar = true pede à API para dispensar o 2FA neste navegador por 7 dias
export const login2fa = (tempToken, codigo, lembrar = false) => dispatch =>
  api.usuario.login2fa(tempToken, codigo, lembrar).then(data => {
    if (data.dispositivoToken && data.user) {
      salvarDispositivo2fa(data.user.email, data.dispositivoToken, data.dispositivoExpira);
    }
    return { user: concluirLogin(data, dispatch).user };
  });

export const logout = () => dispatch => {
  localStorage.removeItem(process.env.REACT_APP_LOCALSTORAGE_AUTH_TOKEN);
  dispatch(userLoggedOut());
};

// o cadastro só envia o código por e-mail; a sessão abre em confirmarCodigoCadastro
export const cadastro = data => () =>
  api.usuario.cadastro(data);

export const confirmarCodigoCadastro = (email, codigo) => dispatch =>
  api.usuario.confirmarCodigoCadastro(email, codigo).then(data => ({
    user: concluirLogin(data, dispatch).user
  }));

export const reenviarCodigoCadastro = email => () =>
  api.usuario.reenviarCodigoCadastro(email);

export const enviarEmailRecuperacaoSenha = email => dispatch =>
  api.usuario.enviarEmailRecuperacaoSenha(email).then(data => {
    dispatch(emailRecuperacaoSenhaEnviado(data.user));
  });

export const confirmarCadastro = token => dispatch =>
  api.usuario.confirmarCadastro(token).then(data => {
    dispatch(cadastroUsuarioConfirmado(data.user));
  });

export const recuperarSenha = data => dispatch =>
  api.usuario.recuperarSenha(data).then(data => {
    dispatch(senhaRecuperada(data.user));
  });

export const confirmarTokenRecuperacaoSenha = token => dispatch =>
  api.usuario.confirmarTokenRecuperacaoSenha(token).then(data => {
    return dispatch(tokenRecuperacaoSenhaConfirmado(data.user));
  });

export const confirmarTrocaEmail = token => dispatch =>
  api.usuario.confirmarTrocaEmail(token).then(data => {
    dispatch(tokenConfirmacaoTrocaEmailConfirmado(data.user));
  });

export const reverterTrocaEmail = token => dispatch =>
  api.usuario.reverterTrocaEmail(token).then(data => {
    dispatch(tokenReverterTrocaEmailConfirmado(data.user));
  });

export const updateUsuario = () => dispatch =>
  api.usuario.getUsuario().then(data => {
    return dispatch(updateUsuarioSucesso(data));
  });
